export default __webpack_public_path__ + "media/ping-logo.61855.png";